<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>内部采购审批列表</el-breadcrumb-item>
    </el-breadcrumb>
      <el-date-picker
        v-model="purchaseRequest.selectDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        size="mini"
        @change="loadPurchaseListApprove"
      >
      </el-date-picker>
      <el-input v-model="purchaseRequest.name" placeholder="请输入内容" size="mini" style="width: 200px;"></el-input>
      <el-select size="mini" v-model="purchaseRequest.state" clearable value filterable placeholder="请选择状态">
        <el-option v-for="item in stateText"
                   :key="item.state"
                   :label="item.name"
                   :value="item.state"></el-option>
      </el-select>
      <el-button size="mini" @click="loadPurchaseListApprove">查询</el-button>
      <el-button size="mini" @click="collectPurchase">汇总</el-button>
      <el-button size="mini" @click="createPurchaseBatch" :disabled="isBatchPurchase">批量采购</el-button>
      <br>
      <span style="font-size: 13px;color: #3a8ee6">合计数量：{{totalNum}} 个</span>
      <span style="font-size: 13px;color: #3a8ee6">合计金额：{{totalMoney}} 元</span>
      <el-table height="550px" :data="inPurchaseOrderList" fit border
                :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :row-style="applyNumPurchaseColor"
                :cell-style="orderStateColor">
        <el-table-column
          label="操作"
          fixed="fixed"
          align="center"
          width="140">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: space-around">
              <el-link type="primary" icon="iconfont icon-yijianshenpi"
                       @click="yijianshenpi(scope.row)" title="一键审批"
                        :disabled="scope.row.state === 6"></el-link>
              <el-link type="primary" icon="iconfont icon-dingdanshenpi"
                       @click="showApproveDialog(scope.row)" title="审批"></el-link>
              <el-link type="primary" icon="iconfont icon-shenpibohui"
                       @click="yijianbohui(scope.row)" title="一键驳回"
                        :disabled="scope.row.state === 6"></el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="collectDate"
          label="汇总日期"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          align="center"
          :formatter="stateFormatter"
          width="100">
        </el-table-column>
        <el-table-column
          prop="productName"
          label="产品名称"
          align="center"
          width="250">
        </el-table-column>
        <el-table-column
          prop="collectNum"
          label="汇总采购申请数量"
          align="center">
        </el-table-column>
        <el-table-column
          prop="approveNum"
          label="审批数量"
          align="center">
        </el-table-column>
        <el-table-column
          label="采购数量"
          align="center"
          v-if="currentOrgLevel > 1"
        >
          <template slot-scope="scope">
            <el-input :disabled="scope.row.state > 1 || scope.row.productTypeName === '自采产品'"
                      size="mini" v-model="scope.row.purchaseNum"
                      @change="changeBatchPurchaseButtonState"
                      onkeyup="value=value.replace(/[^\d]/g,'')"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="practicalNum"
          label="实际库存"
          align="center">
        </el-table-column>
      </el-table>
<!--    <div style="margin-top: 3px;">-->
<!--      <el-pagination-->
<!--        @size-change="handleSizeChange"-->
<!--        @current-change="handleCurrentChange"-->
<!--        :current-page="currentPage"-->
<!--        :page-sizes="[10, 20, 30, 50]"-->
<!--        :page-size="pageSize"-->
<!--        layout="total, sizes, prev, pager, next, jumper"-->
<!--        :total="pageTotal">-->
<!--      </el-pagination>-->
<!--    </div>-->

    <el-dialog
      title="审批"
      :visible.sync="approveDialogVisible"
      width="60%"
      @close="closeApproveDialog"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <el-table :data="childrenOrgInPurchaseList" fit border stripe="stripe" width="100%" :header-cell-style="{background:'#eff3f8', color:'#333'}"
                :cell-style="applyPurchaseStateColor"
                >
        <el-table-column
          label="操作"
          align="center"
          width="80">
          <template slot-scope="scope">
              <el-link type="primary" icon="iconfont icon-shenpibohui"
                       @click="bohui(scope.row)" title="驳回"
                       :disabled="scope.row.state == 5 || scope.row.state == 4 "></el-link>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="purchaseDate"
          label="采购日期" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="state"
          :formatter="applyPurchaseStateFormatter"
          label="状态" width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="productName"
          label="产品名称" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="applyNum"
          label="采购数量" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          label="采购费用" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.purchaseMoney" :disabled="scope.row.state === 4 || scope.row.state === 5"
                      size="mini" ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="inOrgName"
          label="采购机构" width="150">
        </el-table-column>
        <el-table-column
          align="center"
          prop="practicalNum"
          label="实际库存">
        </el-table-column>
        <el-table-column
          align="center"
          label="审批数量" width="150">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.approveNum"
                      :disabled="scope.row.state === 4 || scope.row.state === 5"
                    @change="jisuanfeiyong(scope.row)"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="申请时备注" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.applyComment" size="mini" ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="填写的审批备注" width="150">
          <template slot-scope="scope">
            <el-input v-model="scope.row.approveComment" size="mini" ></el-input>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" :disabled="isApprove" @click="approvePurchaseBatch">审批</el-button>
        <el-button size="mini" @click="resetApprovePurchase">重新审批</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      currentOrgLevel:'',
      authorities:'',
      userId:'',
      currentOrgPurchaseLevel:'',
      purchase:{
        id:'',
        productName:'',
        purchaseDate:'',
        productNo:'',
        purchaseNo:'',
        purchaseMoney:'',
        inOrgId:'',
        outOrgId:'',
        creator:'',
        applyNum:''
      },
      purchaseRequest:{
        selectDate:'',
        orgId:'',
        pageNum:'',
        pageSize:'',
        startDate:'',
        endDate:'',
        name:'',
        state:''
      },
      inPurchaseOrderList:[],
      currentPage: 1,
      pageSize:9999999,
      pageTotal:0,
      stateText:[
        {state:1, name:'正常汇总'},
        {state:2, name:'正常汇总'},
        {state:3, name:'审批中'},
        {state:4, name:'审批通过'},
        {state:5, name:'审批驳回'},
        {state:6, name:'审批完成'},
      ],
      applyPurchaseStateText:[
        {state:1, name:'提起申请'},
        {state:2, name:'已作废'},
        {state:3, name:'审批中'},
        {state:4, name:'审批通过'},
        {state:5, name:'审批驳回'},
        {state:6, name:'审批完成'},
      ],
      approveDialogVisible:false,
      childrenOrgInPurchaseList:[],
      collectId:'',
      isApprove:true,
      isBatchPurchase:true,
      operateType:1,
      totalNum:'',
      totalMoney:'',
      isReset:false,
    }
  },
  methods:{
    //判断批量采购按钮是否可用
    changeBatchPurchaseButtonState(){
      let result = false;
      for (let i = 0; i<this.inPurchaseOrderList.length; i++){
        if (this.inPurchaseOrderList[i].state === 1 && this.inPurchaseOrderList[i].purchaseNum > 0){
          result = true;
        }
      }
      if (result){
        this.isBatchPurchase = false;
      } else {
        this.isBatchPurchase = true;
      }
    },
    //判断批量审批按钮是否可用
    changeBatchApproveButtonState(){
      let result = false;
      for (let i = 0; i<this.childrenOrgInPurchaseList.length; i++){
        if (this.childrenOrgInPurchaseList[i].state === 3 && this.childrenOrgInPurchaseList[i].approveNum > 0){
          result = true;
        }
        if (this.childrenOrgInPurchaseList[i].state === 5){
          result = true;
        }
      }
      if (result){
        this.isApprove = false;
      } else {
        this.isApprove = true;
      }
    },
    //批量审批
    async approvePurchaseBatch(){
      this.isApprove = true;
      if (this.operateType === 1){
        const {data:res} = await this.$http.post(`/inPurchase/approve/${this.userId}`, this.childrenOrgInPurchaseList)
        if (res.code === 200){
          this.$message.success("操作成功！");
        }
      }
      if (this.operateType === 2){
        const {data:res} = await this.$http.post(`/inPurchase/approve/reset/${this.userId}`, this.childrenOrgInPurchaseList)
        if (res.code === 200){
          this.$message.success("操作成功！");
        }
      }
      setTimeout(() =>{
          this.isApprove = false;
        },5000
      )
      await this.loadPurchaseListApprove();
      this.closeApproveDialog();
    },
    async loadCollectChildrenPurchase(){
      const {data:res} = await this.$http.get(`/inPurchase/children/purchase/collectId/${this.collectId}`)
      if (res.code === 200){
        this.childrenOrgInPurchaseList = res.data;

        this.childrenOrgInPurchaseList.map((item) => {
          if (item.approveNum === 0 && item.state !== 5){
            item.approveNum = item.applyNum;
          }
        })
      }

      this.changeBatchApproveButtonState();
    },
    showApproveDialog(data){
      this.collectId = data.id;
      this.loadCollectChildrenPurchase();
      this.approveDialogVisible = true;
    },
    async yijianshenpi(data){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.get(`/inPurchase/children/purchase/collectId/${data.id}`)
      if (res.code === 200){
        this.childrenOrgInPurchaseList = res.data;
        this.childrenOrgInPurchaseList.map((item) => {
          item.approveNum = item.applyNum;
        })
      }
      const {data:res1} = await this.$http.post(`/inPurchase/approve/${this.userId}`, this.childrenOrgInPurchaseList)
      if (res1.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadPurchaseListApprove();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    closeApproveDialog(){
      this.approveDialogVisible = false;
    },
    //重新审批
    resetApprovePurchase(){
      this.isReset = true;
      this.childrenOrgInPurchaseList.map((item) => {
        item.state = 3;
        item.approveNum = item.applyNum;
        item.purchaseMoney = (item.applyNum * item.productPrice).toFixed(2);
      })
      this.isApprove = false;
      this.operateType = 2;
    },
    async loadPurchaseListApprove(){
      this.totalMoney = '';
      this.totalNum = '';
      this.purchaseRequest.startDate = '';
      this.purchaseRequest.endDate = '';
      if (this.purchaseRequest.selectDate !== null){
        this.purchaseRequest.startDate = this.purchaseRequest.selectDate[0];
        this.purchaseRequest.endDate = this.purchaseRequest.selectDate[1];
      }
      this.purchaseRequest.pageNum = this.currentPage;
      this.purchaseRequest.pageSize = this.pageSize;
      this.purchaseRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/inPurchase/query/collect`, this.purchaseRequest)
      if (res.code === 200){
        this.inPurchaseOrderList = res.data.list;
        this.pageTotal = res.data.total;
      }

      const {data:res1} = await this.$http.post(`/inPurchase/query/approve/total`, this.purchaseRequest)
      if (res1.code === 200 && res1.data !== null){
        this.totalNum = res1.data.approveNum;
        this.totalMoney = res1.data.totalMoney;
      }
    },
    async createPurchaseBatch(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/inPurchase/collect/apply/batch/${this.userId}`, this.inPurchaseOrderList);
      if (res.code === 200){
        this.$message.success("操作成功!");
      }
      await this.loadPurchaseListApprove();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    // async createPurchaseOne(data){
    //   const {data:res} = await this.$http.post(`/inPurchase/addOne`, data);
    //   if (res.code === 200){
    //     this.$message.success("操作成功!");
    //   }
    // },
    async collectPurchase(){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.get(`/inPurchase/collect/orgId/${this.currentOrgId}/creator/${this.userId}`)
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadPurchaseListApprove();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    //状态显示颜色方法
    orderStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===2){
        return 'color:#3366ff';
      } else if (row.state === 2 && columnIndex ===2){
        return 'color:#3385ff';
      } else if (row.state === 3 && columnIndex ===2){
        return 'color:#ffa64d';
      } else if (row.state === 4 && columnIndex ===2){
        return 'color:#0CB618';
      } else if (row.state === 5 && columnIndex ===2){
        return 'color:#a64dff';
      } else if (row.state === 6 && columnIndex ===2){
        return 'color:#8585ad';
      }
    },
    //状态方法
    stateFormatter(row){
      let value = "";
      for (let i = 0; i < this.stateText.length; i++){
        let item = this.stateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    //状态显示颜色方法
    applyPurchaseStateColor({row,columnIndex}){
      if (row.state === 1 && columnIndex ===2){
        return 'color:#3385ff';
      } else if (row.state === 2 && columnIndex ===2){
        return 'color:#EA1B28';
      } else if (row.state === 3 && columnIndex ===2){
        return 'color:#ffa64d';
      } else if (row.state === 4 && columnIndex ===2){
        return 'color:#0CB618';
      } else if (row.state === 5 && columnIndex ===2){
        return 'color:#a64dff';
      } else if (row.state === 6 && columnIndex ===2){
        return 'color:#8585ad';
      }
    },
    applyNumPurchaseColor({row,columnIndex}){
      if (row.collectNum > row.practicalNum && row.state < 6){
       return { "background-color": "#FFDDAA" }
      }
    },
    //状态方法
    applyPurchaseStateFormatter(row){
      let value = "";
      for (let i = 0; i < this.applyPurchaseStateText.length; i++){
        let item = this.applyPurchaseStateText[i];
        if (row.state === item.state) {
          value = item.name;
          break;
        }
      }
      return value;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadPurchaseListApprove();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadPurchaseListApprove();
    },
    async yijianbohui(data){
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.get(`/inPurchase/batch/returnDown/${data.id}/${this.userId}`)
      if(res.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadPurchaseListApprove();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    },
    async bohui(data){
      data.state = 5;
      data.approveNum = 0;
      // const {data:res} = await this.$http.get(`/inPurchase/returnDown/${data.id}`)
      // if(res.code === 200){
      //   this.$message.success("操作成功！");
      //
      //   //判断是否是重新审批，如果是，则先不刷新页面数据
      //   if (!this.isReset){
      //     await this.loadCollectChildrenPurchase();
      //     await this.loadPurchaseListApprove();
      //   }
      // }
    },
    jisuanfeiyong(row){
      row.purchaseMoney = (row.productPrice * row.approveNum).toFixed(1);
    }
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.currentOrgPurchaseLevel = window.sessionStorage.getItem("currentOrgPurchaseLevel");
    this.currentOrgLevel = window.sessionStorage.getItem("orgLevel");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadPurchaseListApprove();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 90vh;
}

.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.left_inner_con{
  width: 300px;
  height: 90vh;
  overflow-y: auto;
  margin-right: 10px;
  //background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
    text-align: center !important;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #ffffff !important;
  .el-dialog__title{
    color: #ffffff;
  }
  .el-dialog__close{
    color: #ffffff !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  color: #ffffff !important;
  .el-dialog__title{
    color: #ffffff;
  }
  .el-dialog__close{
    color: #ffffff !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InPurchaseApprove.vue